import Avatar from "../Avatar/Avatar";
import styles from "./avatarGroup.css";

/**
 * Renders a group of user avatars.
 *
 * @param {Object} props - The component props.
 * @param {Array} props.users - The list of user objects to display.
 * Each user object must have an `id` property which is used as the key.
 * @return {JSX.Element|null} - A list of user avatars if the users array is not empty;
 * otherwise, null.
 */
function AvatarGroup({ users }) {
  if (!users?.length) {
    return null;
  }

  return (
    <ul className={styles.avatarGroup}>
      {users.map((user) => (
        <li key={user.id}>
          <Avatar user={user} size="30px" />
        </li>
      ))}
    </ul>
  );
}

export default AvatarGroup;
